<template>
    <div class="search_nav">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="订单编号：">
                <el-input v-model="formInline.orderNo" placeholder="请输入充电订单编号"></el-input>
            </el-form-item>
            <el-form-item label="订单来源：">
                <el-select style="width: 150px;" v-model="formInline.partnerId" filterable placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="自营" value="0"></el-option>
                    <el-option
                    v-for="item in partnerList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model="formInline.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="站-桩-枪：">
                <el-select style="width: 120px;" v-model="formInline.stationId" filterable placeholder="全部" @change="stationChange">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                    v-for="item in stationOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
                <el-select style="width: 120px;" v-model="formInline.pileNo" filterable placeholder="全部" @change="pileChange">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                    v-for="item in pileOptions"
                    :key="item.pileNo"
                    :label="item.name"
                    :value="item.pileNo">
                    </el-option>
                </el-select>
                <el-select style="width: 120px;" v-model="formInline.gunIndex" filterable placeholder="全部">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                    v-for="item in gunOptions"
                    :key="item.gunIndex"
                    :label="item.name"
                    :value="item.gunIndex">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间维度：">
                <el-select style="width: 150px;" v-model="formInline.timeQueryType" placeholder="请选择">
                    <el-option label="结束时间" value="0"></el-option>
                    <el-option label="开始时间" value="1"></el-option>
                </el-select>
                <el-date-picker
                    v-model="formInline.dateRange"
                    type="datetimerange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    range-separator="至"
                    start-placeholder="起始时间"
                    end-placeholder="结束时间"
                    style="width: 350px;"
                />
            </el-form-item>
            <el-form-item label="支付方式：">
                <el-select style="width: 150px;" v-model="formInline.payType" filterable placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="账户余额" :value="1"></el-option>
                    <el-option label="微信支付分" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="充电状态：">
                <el-select style="width: 150px;" v-model="formInline.chargeState" filterable placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="启动中" value="0"></el-option>
                    <el-option label="正在充电" value="1"></el-option>
                    <el-option label="充电结束" value="2"></el-option>
                    <el-option label="失败" value="3"></el-option>
                    <el-option label="挂起" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <div class="button_group">
                    <el-button type="primary" @click="getList">搜索</el-button>
                    <el-button type="primary" @click="refresh">刷新</el-button>
                </div>
            </el-form-item>
        </el-form>
    </div>

    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
        <el-table-column label="序号" width="60">
            <template #default="scope">
                <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电订单编号" width="300" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.orderId || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="订单来源" width="120">
            <template #default="scope">
                <span>{{ scope.row.orderSource || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="手机号" width="130">
            <template #default="scope">
                <span>{{ scope.row.phone || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="场站" width="150" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.stationName || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="桩" width="100" show-overflow-tooltip>
            <template #default="scope">
                <span>{{ scope.row.pileNo || '-' }}号桩</span>
            </template>
        </el-table-column>
        <el-table-column label="枪" width="80">
            <template #default="scope">
                <span>{{ scope.row.gunNo || '-' }}枪</span>
            </template>
        </el-table-column>
        <el-table-column label="开始时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.startTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="结束时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.endTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电时长" width="100">
            <template #default="scope">
                <span>{{ scope.row.chargeDuration || '-' }}分钟</span>
            </template>
        </el-table-column>
        <el-table-column label="充电量" width="100">
            <template #default="scope">
                <span>{{ scope.row.chargeQuantity || '-' }}KWh</span>
            </template>
        </el-table-column>
        <el-table-column label="充电电费" width="100">
            <template #default="scope">
                <span>{{ scope.row.electricityFee || '0.00' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电服务费" width="120">
            <template #default="scope">
                <span>{{ scope.row.serviceFee || '0.00' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="折扣充电服务费" width="140">
            <template #default="scope">
                <span>{{ scope.row.discountServiceFee || '0.00' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="实付充电服务费" width="140">
            <template #default="scope">
                <span>{{ scope.row.actualServiceFee || '0.00' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="实付金额" width="100">
            <template #default="scope">
                <span>{{ scope.row.actualFee || '0.00' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="结算时间" width="180">
            <template #default="scope">
                <span>{{ scope.row.settleTime || '-' }}</span>
            </template>
        </el-table-column>
        <el-table-column label="支付方式" width="120">
            <template #default="scope">
                <span>{{ payTypeFormat(scope.row.payType) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="充电状态" width="100">
            <template #default="scope">
                <span>{{ chargeStateFormat(scope.row.chargeState) }}</span>
            </template>
        </el-table-column>

        <el-table-column label="操作" width="400" fixed="right">
            <template #default="scope">
                <el-button type="primary" @click="viewDetail(scope.row)">查看订单详情</el-button>
                <el-button type="warning" @click="manualPay(scope.row)" v-if="scope.row.partnerId === 0 && (scope.row.chargeState === 2 || scope.row.chargeState === 4)">手动扣费</el-button>
                <el-button type="danger" @click="suspendOrder(scope.row)" v-if="scope.row.canSuspend == true">挂起</el-button>
                <el-button type="danger" @click="stopCharge(scope.row)" v-if="scope.row.chargeState < 2">停止充电</el-button>
            </template>
        </el-table-column>
    </el-table>

    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 订单详情弹窗 -->
    <el-dialog v-model="showDetail" title="订单详情" :close-on-click-modal="false" width="1100px">
      <div class="dialog-content">
        <!-- 用户信息 -->
        <div class="detail-section">
            <h3 class="section-title">用户信息:</h3>
            <div class="info-row">
                <span class="label">用户名称:</span>
                <span class="value">{{ detailData.userName || '--' }}</span>
                <span class="label">用户手机号:</span>
                <span class="value">{{ detailData.phone || '--' }}</span>
                <span class="label">车牌号:</span>
                <span class="value highlight">{{ detailData.license || '--' }}</span>
            </div>
            <!-- <div class="info-row">
                <span class="label">车辆用途:</span>
                <span class="value highlight">---</span>
                <span class="label">注册日期:</span>
                <span class="value">{{ detailData.registerDate || '2026-01-01' }}</span>
                <span class="label">上次充电日期:</span>
                <span class="value">{{ detailData.lastChargeDate || '2026-01-01' }}</span>
            </div> -->
        </div>

        <!-- 充电信息 -->
        <div class="detail-section">
            <h3 class="section-title">充电信息:</h3>
            <div class="info-row">
                <span class="label">站-桩-枪:</span>
                <span class="value">{{ detailData.stationName || '--' }}-{{ detailData.pileIndex || '--' }}号桩-{{ detailData.gunNo || '--' }}枪</span>
            </div>
            <div class="info-row">
                <span class="label">充电订单编号:</span>
                <span class="value">{{ detailData.transactionId || '--' }}</span>
            </div>
            <div class="info-row">
                <span class="label">起始SOC:</span>
                <span class="value" v-if="detailData.pileType != 1">{{ detailData.startSoc || '--' }}%</span>
                <span class="label">充电开始时间:</span>
                <span class="value">{{ detailData.startTime || '--' }}</span>
                <span class="label">订单状态:</span>
                <span class="value highlight">{{ chargeStatusFormat(detailData.chargeStatus) }}</span>
            </div>

            <!-- 功率曲线图 -->
            <div class="chart-section">
                <span class="label">功率曲线图:</span>
                <div class="chart-container">
                    <h4 class="chart-title" v-if="detailData.pileType != 1">快充功率曲线图</h4>
                    <h4 class="chart-title" v-else>慢充功率曲线图</h4>
                    <div id="powerChart" class="chart-content"></div>
                </div>
            </div>

            <!-- 充电统计 -->
            <div class="charge-summary">
                <div class="summary-row">
                    <span class="label">结束SOC:</span>
                    <span class="value" v-if="detailData.pileType != 1">{{ detailData.endSoc || '--' }}%</span>
                    <span class="label">总充电量:</span>
                    <span class="value">{{ detailData.chargeQuantity || '--' }}kwh</span>
                    <span class="label">充电结束时间:</span>
                    <span class="value">{{ detailData.endTime || '--' }}</span>
                    <span class="label">账单交易时间:</span>
                    <span class="value">{{ detailData.tradeTime || '--' }}</span>
                </div>
                <div class="summary-row">
                    <span class="label">充电电费:</span>
                    <span class="value">{{ detailData.electricityFee || '--' }}元</span>
                    <span class="label">充电服务费:</span>
                    <span class="value">{{ detailData.serviceFee || '--' }}元</span>
                    <span class="label">充电金额:</span>
                    <span class="value">{{ detailData.totalAmt || '--' }}元</span>
                    <span class="label">折扣充电服务费:</span>
                    <span class="value">{{ detailData.discountAmt || '--' }}元</span>
                </div>
                <div class="summary-row">
                    <span class="label">实付金额:</span>
                    <span class="value">{{ detailData.payAmt || '--' }}元</span>
                    <span class="label">扣费类型:</span>
                    <span class="value">{{ detailData.payFlag === 3 ? '手动扣费' : '自动扣费' }}</span>
                    <span class="label">支付方式:</span>
                    <span class="value">{{ payTypeFormat(detailData.payType) || '--' }}</span>
                    <span class="label">支付后余额:</span>
                    <span class="value">{{ detailData.remainingAmt || '--' }}元</span>
                </div>
            </div>
        </div>

        <!-- 计费信息 -->
        <div class="detail-section">
            <h3 class="section-title">计费信息:</h3>
            <div class="billing-table">
                <table>
                    <thead>
                        <tr>
                            <th>时段</th>
                            <th>时段类型</th>
                            <th colspan="3">电价</th>
                            <th>充电量</th>
                            <th colspan="3">消费金额</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th></th>
                            <th>电费</th>
                            <th>服务费</th>
                            <th>单价</th>
                            <th></th>
                            <th>充电电费</th>
                            <th>充电服务费</th>
                            <th>充电金额</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in detailData.chargeDetail" :key="index">
                            <td>{{ item.beginTime }} - {{ item.endTime }}</td>
                            <td>{{ruleTypeFormat(item.ruleType)}}</td>
                            <td>{{item.electricityPrice}}</td>
                            <td>{{item.servicePrice}}</td>
                            <td>{{(item.electricityPrice + item.servicePrice).toFixed(3)}}</td>
                            <td>{{item.electricity}}</td>
                            <td>{{item.electricityFee}}</td>
                            <td>{{item.serviceFee}}</td>
                            <td>{{(item.electricityFee + item.serviceFee).toFixed(3)}}</td>
                        </tr>
                        <!-- <tr>
                            <td>00:00-01:00:00</td>
                            <td>谷段</td>
                            <td>2.00</td>
                            <td>2.00</td>
                            <td>4.00</td>
                            <td>2.00</td>
                            <td>4.00</td>
                            <td>4.00</td>
                            <td>8.00</td>
                            <td>服务费8折抵扣券抵扣</td>
                        </tr> -->
                    </tbody>
                </table>
            </div>
            <div v-if="detailData.remark" class="remark-display">
                <span class="label">备注：</span>
                <span class="remark-content">{{ detailData.remark }}</span>
            </div>
        </div>
     </div>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';

export default {
name:'NoFeeOrderManage',
data() {
    return {
        tableData: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        showDetail: false,
        detailData: {},
        partnerList: [],
        stationOptions: [],
        stationTree: {},
        pileOptions: [],
        gunOptions: [],
        formInline: {
            orderNo: '',
            partnerId: '',
            pileNo: '',
            gunIndex: '',
            stationId: '',
            timeQueryType: '0',  // 新增：时间维度
            dateRange: [],               // 新增：时间范围数组
            payType: '',
            chargeState: '',
            remark: ''
        },
        chartTimeData: [], // 快充功率曲线图数据--时间轴
        chartPowertData: [], // 快充功率曲线图数据--功率
        chartVoltageData: [], // 快充功率曲线图数据--电压
        chartCurrentData: [], // 快充功率曲线图数据--电流
        chartSOCData: [], // 快充功率曲线图数据--SOC
    }
},
mounted(){
    this.getList();
    this.getStationOptions();
    this.getPartnerList();
},
watch: {
    '$store.state.stationList': {
        handler(newVal) {
            if (newVal && newVal.length > 0) {
                this.stationOptions = newVal;
            }
        },
        immediate: true
    }
},
methods:{
    manualPay(row){
        let that = this;
        that.$confirm('确认手动扣费吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            that.$axios.post(that.$store.state.platformApi + "order/manualDeduction",{
                transactionId: row.orderId
            }).then(result => {
                if(result.code === 200){
                    that.$message.success('正在处理中，请等待');
                    that.getList();
                }
            });
        }).catch(() => {
            
        });
    },
    suspendOrder(row){
        let that = this;
        that.$confirm('确认挂起订单吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            that.$axios.post(that.$store.state.platformApi + "order/suspend/"+row.orderId,{}).then(result => {
                if(result.code === 200){
                    that.$message.success('订单挂起成功');
                    that.getList();
                }
            });
        }).catch(() => {
            
        });
    },
    stopCharge(row){
        let that = this;
        that.$confirm('确认停止充电吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            that.$axios.post(that.$store.state.platformApi + "ctrl/remoteStop",{
                transactionId: row.orderId
            }).then(result => {
                if(result.code === 200){
                    that.$message.success('停止充电成功');
                    that.getList();
                }
            });
        }).catch(() => {
            
        });
    },
    getPartnerList(){
        //获取合作方列表
        let that = this;that.$axios.post(that.$store.state.platformApi + "partner/list", {}).then(result => {
            if(result.code === 200){
                that.partnerList = result.data || [];
            }
        });
    },
    getTree(){
        let that = this;
        that.$axios.post(that.$store.state.platformApi + "gun/tree/"+that.formInline.stationId, {}).then(result => {
            if(result.code == 200){
                that.stationTree = result.data;
                that.pileOptions = that.stationTree.piles || [];
                that.formInline.pileNo = '';
                that.formInline.gunIndex = '';
            }
        });
    },
    stationChange(){
        this.formInline.pileNo = '';
        this.formInline.gunIndex = '';
        this.gunOptions = [];
        this.pileOptions = [];
        if(this.formInline.stationId){
            this.getTree();
        }
    },
    pileChange(){
        this.formInline.gunIndex = '';
        this.gunOptions = [];
        // 根据pileNo获取对应的gunOptions
        let pile = this.pileOptions.find(pile => pile.pileNo === this.formInline.pileNo);
        if(pile){
            this.gunOptions = pile.guns || [];
        }
    },
    getList(){
        let that = this;
        let param = {
            page: that.currentPage,
            pageSize: that.pageSize
        };
        Object.keys(this.formInline).forEach(key => {
            if(this.formInline[key]){
                // 处理时间范围
                if(key === 'dateRange' && this.formInline.dateRange.length === 2){
                    param.startTime = this.formInline.dateRange[0];
                    param.endTime = this.formInline.dateRange[1];
                } else if(key !== 'dateRange'){
                    param[key] = this.formInline[key];
                }
            }
        });
        if(param.partnerId === '0'){
            param.partnerId = 0;
        }
        param.timeQueryType === '0' ? param.timeQueryType = 0 : param.timeQueryType = Number(param.timeQueryType);
        if(param.chargeState !== undefined){
            param.chargeState = Number(param.chargeState);
        }
        
        that.$axios.post(that.$store.state.platformApi + "order/unpay/page", JSON.stringify(param)).then(result => {
            if(result.code == 200){
                that.tableData = result.data.records;
                that.total = result.data.total;
            }
        });
    },
    getStationOptions(){
        let that = this;
        that.stationOptions = that.$store.state.stationList || [];
    },
    handleSizeChange(val) {
        this.pageSize = val;
        this.getList();
    },
    handleCurrentChange(val) {
        this.currentPage = val;
        this.getList();
    },
    refresh() {
        this.formInline = {
            orderNo: '',
            partnerId: '',
            pileNo: '',
            gunIndex: '',
            stationId: '',
            timeQueryType: '0',  // 时间维度，字符串以匹配下拉选项value
            dateRange: [],               // 新增：时间范围数组
            payType: '',
            chargeState: '',
            remark: ''
        };
        this.currentPage = 1;
        this.getList();
    },
    payTypeFormat(payType){
        switch(payType){
            case 1:
                return '账户余额';
            case 2:
                return '微信支付分';
            default:
                return '-';
        }
    },
    chargeStateFormat(chargeState){
        switch(chargeState){
            case 0:
                return '启动中';
            case 1:
                return '正在充电';
            case 2:
                return '充电结束';
            case 3:
                return '失败';
            case 4:
                return '挂起';
            default:
                return '-';
        }
    },
    chargeStatusFormat(chargeStatus){
        switch(chargeStatus){
            case 0:
                return '启动中';
            case 1:
                return '充电中';
            case 2:
                return '充电结束';
            case 3:
                return '充电失败';
            case 4:
                return '已挂起';
            default:
                return '-';
        }
    },
    ruleTypeFormat(ruleType){
        switch(ruleType){
            case 1:
                return '尖段';
            case 2:
                return '峰段';
            case 3:
                return '平段';
            case 4:
                return '谷段';
            default:
                return '-';
        }
    },
    viewDetail(row) {
        this.getOrderDetail(row.orderId);
        this.showDetail = true;
    },
    getOrderDetail(orderId){
        let that = this;
        that.$axios.post(that.$store.state.platformApi + "order/detail/"+orderId, {}).then(result => {
            if(result.code == 200){
                that.detailData = result.data;
                //处理快充功率曲线图数据
                //如果that.detailData.performanceData存在，且长度大于0，才处理数据
                if(that.detailData.performanceData && that.detailData.performanceData.length > 0){
                    // 处理功率数据
                    that.chartTimeData = that.detailData.performanceData.map(item => item.context.reportTime === null ? '0:00' : item.context.reportTime);
                    that.chartPowertData = that.detailData.performanceData.map(item => item.context.power === null ? 0 : item.context.power);
                    // 处理电压数据
                    that.chartVoltageData = that.detailData.performanceData.map(item => item.context.voltage === null ? 0 : item.context.voltage);
                    // 处理电流数据
                    that.chartCurrentData = that.detailData.performanceData.map(item => item.context.electric === null ? 0 : item.context.electric);

                    if(that.detailData.pileType != 1){
                        // 处理SOC数据
                        that.chartSOCData = that.detailData.performanceData.map(item => item.context.soc === null ? 0 : item.context.soc);
                        // 延迟初始化图表，等待弹窗渲染完成
                        console.log('非慢充，处理SOC数据---');
                        setTimeout(() => {
                            that.initPowerChart();
                        }, 300);
                    }else{
                        console.log('慢充，不处理SOC数据///');
                        // 延迟初始化图表，等待弹窗渲染完成
                        setTimeout(() => {
                            that.initPowerChart2();
                        }, 300);
                    }
                }else{
                    console.log('没有功率数据，不处理任何数据///');
                    that.chartTimeData = [];
                    that.chartPowertData = [];
                    that.chartVoltageData = [];
                    that.chartCurrentData = [];
                    that.chartSOCData = [];
                    // 延迟初始化图表，等待弹窗渲染完成
                    setTimeout(() => {
                        that.initPowerChart();
                    }, 300);
                }
            }
        });
    },
    initPowerChart() {
        let that = this;
        const chartDom = document.getElementById('powerChart');
        if (!chartDom) return;
        
        const myChart = this.$echarts.init(chartDom);
        
        const option = {
            title: {
                text: '',
                left: 'center'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                data: ['功率', '电压', '电流', 'SOC%'],
                bottom: 10
            },
            grid: {
                left: '3%',
                right: '8%',
                bottom: '15%',
                top: '5%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: that.chartTimeData
            },
            yAxis: [{
                type: 'value',
                name: '功率/V',
                min: 0,
                max: 450,
                interval: 50,
                axisLabel: {
                    formatter: '{value}'
                }
            }, {
                type: 'value',
                name: 'SOC%',
                min: 0,
                max: 100,
                interval: 10,
                axisLabel: {
                    formatter: '{value}%'
                }
            }],
            series: [{
                name: '功率',
                type: 'line',
                smooth: true,
                data: that.chartPowertData,
                lineStyle: {
                    color: '#3b82f6',
                    width: 2
                }
            }, {
                name: '电压',
                type: 'line',
                smooth: true,
                data: that.chartVoltageData,
                lineStyle: {
                    color: '#f97316',
                    width: 2
                }
            }, {
                name: '电流',
                type: 'line',
                smooth: true,
                data: that.chartCurrentData,
                lineStyle: {
                    color: '#eab308',
                    width: 2
                }
            }, {
                name: 'SOC%',
                type: 'line',
                yAxisIndex: 1,
                smooth: true,
                data: that.chartSOCData,
                lineStyle: {
                    color: '#22c55e',
                    width: 2
                }
            }]
        };
        
        myChart.setOption(option,true);
        
        // 窗口大小变化时重绘图表
        window.addEventListener('resize', () => {
            myChart.resize();
        });
    },
    initPowerChart2() {
        let that = this;
        const chartDom = document.getElementById('powerChart');
        if (!chartDom) return;
        
        const myChart = this.$echarts.init(chartDom);
        
        const option = {
            title: {
                text: '',
                left: 'center'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                data: ['功率', '电压', '电流'],
                bottom: 10
            },
            grid: {
                left: '3%',
                right: '8%',
                bottom: '15%',
                top: '5%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: that.chartTimeData
            },
            yAxis: [{
                type: 'value',
                name: '功率/V',
                min: 0,
                max: 450,
                interval: 50,
                axisLabel: {
                    formatter: '{value}'
                }
            }],
            series: [{
                name: '功率',
                type: 'line',
                smooth: true,
                data: that.chartPowertData,
                lineStyle: {
                    color: '#3b82f6',
                    width: 2
                }
            }, {
                name: '电压',
                type: 'line',
                smooth: true,
                data: that.chartVoltageData,
                lineStyle: {
                    color: '#f97316',
                    width: 2
                }
            }, {
                name: '电流',
                type: 'line',
                smooth: true,
                data: that.chartCurrentData,
                lineStyle: {
                    color: '#eab308',
                    width: 2
                }
            }]
        };
        
        myChart.setOption(option,true);
        
        // 窗口大小变化时重绘图表
        window.addEventListener('resize', () => {
            myChart.resize();
        });
    }
}
}
</script>

<style lang="scss" scoped>
.search_nav{
    padding: 15px;
    background: #fff;
    margin-bottom: 15px;
}
.button_group{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    button{
        margin-left: 10px;
    }
}

/* 订单详情弹窗样式 */
.detail-section {
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #eee;
    border-radius: 4px;
}

.section-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    padding-bottom: 5px;
    border-bottom: 1px solid #eee;
}

.info-row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 10px;
    line-height: 30px;
}

.label {
    font-size: 13px;
    color: #666;
    min-width: 80px;
}

.value {
    font-size: 13px;
    color: #333;
    min-width: 120px;
}

.highlight {
    color: #e74c3c;
}

.highlight-price {
    color: #e74c3c;
    font-weight: bold;
    font-size: 16px;
}

.small-text {
    font-size: 11px;
    color: #999;
}

.chart-section {
    margin-top: 15px;
}

.chart-container {
    margin-top: 10px;
    border: 1px solid #eee;
    padding: 15px;
    border-radius: 4px;
}

.chart-title {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
}

.chart-content {
    width: 100%;
    height: 280px;
}

.charge-summary {
    margin-top: 15px;
    padding: 15px;
    background: #fafafa;
    border-radius: 4px;
}

.summary-row {
    display: flex;
    flex-wrap: wrap;
    gap: 25px;
    margin-bottom: 10px;
}

.billing-table {
    margin-top: 10px;
    overflow-x: auto;
}

.billing-table table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
}

.billing-table th,
.billing-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
}

.billing-table th {
    background: #f5f5f5;
    font-weight: bold;
    color: #333;
}

.remark-display {
    margin-top: 15px;
    padding: 10px;
    background: #fff5f5;
    border-left: 3px solid #e74c3c;
    border-radius: 4px;
}

.remark-display .label {
    font-size: 13px;
    color: #666;
    font-weight: bold;
}

.remark-content {
    font-size: 13px;
    color: #e74c3c;
    font-weight: bold;
}

.billing-table td {
    color: #666;
}
</style>